module.exports = __webpack_public_path__ + "media/images/bsmart/icons/da_svolgere_simulazione-7fd0c19d8e816174ea8b3760ca0cb63b.svg";